import { render } from "./ZakatRecheckout.vue?vue&type=template&id=4fc94bcc"
import script from "./ZakatRecheckout.vue?vue&type=script&lang=js"
export * from "./ZakatRecheckout.vue?vue&type=script&lang=js"
script.render = render

export default script